import React, { useEffect } from 'react';

import Button from '@atlaskit/button/standard-button';
import AddIcon from '@atlaskit/icon/glyph/add';

import { Popup } from '@qality/common-components/src/atoms/Popup';
import { ReportBugsContext } from '@qality/common-components/src/lib/ReportBugsProvider';
import { ReportedBugsList } from '@qality/common-components/src/molecules/ReportedBugsList';
import { SearchBug } from '@qality/common-components/src/molecules/SearchBug';

import { ContainerStyled, NoneBugsText } from './BugsTableCell.styled';

type Props = {
  readOnly: boolean;
  closePopup: boolean;
};

const BugsTableCell = ({ readOnly, closePopup }: Props) => {
  const {
    init,
    linkedIssuesCount,
    setSearchValue,
    isCreateOpen,
    setIsCreateOpen,
    isReportOpen,
    setIsReportOpen,
  } = React.useContext(ReportBugsContext);

  const handleToggleReportPopup = () => {
    init();
    setIsReportOpen((i) => !i);
    setIsCreateOpen(false);
  };

  const handleToggleCreatePopup = () => {
    setIsReportOpen(false);
    setIsCreateOpen((i) => !i);
  };

  const handleCloseReportPopup = () => {
    setIsReportOpen(false);
  };

  const handleCloseCreatePopup = () => {
    setIsCreateOpen(false);
    setSearchValue('');
  };

  useEffect(() => {
    if (closePopup) {
      handleCloseReportPopup();
    }
  }, [closePopup]);

  return (
    <ContainerStyled>
      {linkedIssuesCount > 0 ? (
        <Popup
          header='Bugs reported in the Test Step'
          isOpen={isReportOpen}
          onClose={handleCloseReportPopup}
          placement='bottom-end'
          trigger={(triggerProps) => (
            <Button
              appearance='link'
              spacing='none'
              onClick={handleToggleReportPopup}
              {...triggerProps}
            >
              {linkedIssuesCount} {linkedIssuesCount === 1 ? 'bug' : 'bugs'}
            </Button>
          )}
        >
          <ReportedBugsList readOnly={readOnly} />
        </Popup>
      ) : (
        <NoneBugsText>None</NoneBugsText>
      )}
      {!readOnly && (
        <Popup
          header='Report a bug'
          isOpen={isCreateOpen}
          onClose={handleCloseCreatePopup}
          placement='bottom-end'
          trigger={(triggerProps) => (
            <Button
              isSelected={isCreateOpen}
              onClick={handleToggleCreatePopup}
              appearance='subtle-link'
              spacing='none'
              style={{ alignSelf: 'center' }}
              {...triggerProps}
              iconBefore={<AddIcon size='small' />}
            />
          )}
        >
          {isCreateOpen && (
            <SearchBug onCreateIssueCallback={handleCloseCreatePopup} />
          )}
        </Popup>
      )}
    </ContainerStyled>
  );
};

export default BugsTableCell;
